export const SET_ALL_SELECTORS = 'setAllSelectors'

export const OPEN_SELECTOR = 'openSelector'
export const CLOSE_SELECTOR = 'closeSelector'

export const ADD_COMPONENT_TO_SELECTORS = 'addComponentToSelectors'
export const REMOVE_COMPONENT_FROM_SELECTORS = 'removeComponentFromSelectors'
export const SET_SELECTORS_OTHER_CONTENTS = 'setSelectorsOtherContents'

export const SET_SELECTOR_STATE = 'setSelectorState'

export const SET_SELECTED_COMPONENT_SELECTORS = 'setSelectedComponentSelectors'
